import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import AOS from 'aos/dist/aos.js';

const navigator = document.querySelector("nav");
const navbtn = document.querySelector('.nav-btn');
const close = document.querySelector(".close-menu"); 
const out = document.querySelector("main");

navbtn.addEventListener("click", function(){
    navigator.classList.add('show');
});

close.addEventListener("click", function(){
    navigator.classList.remove('show');
});

out.addEventListener("click", function(){
    navigator.classList.remove('show');
});


const header = document.querySelector("header");

window.addEventListener('scroll', () => (window.scrollY > 200) ? header.classList.add('reduce_header') :  header.classList.remove('reduce_header')  );

window.addEventListener('resize', function(){
    document.querySelector("nav").classList.remove('show');
});

AOS.init({
    once: true,
});

document.addEventListener('DOMContentLoaded', function () {
    const timeField = document.getElementById('form_time');
    if (timeField) {
      timeField.value = Math.floor(Date.now() / 1000); // Tiempo UNIX en segundos
    }
});